import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, Chip, Grid, IconButton, Modal, Stack, Tab, Typography } from "@mui/material";

import { Edit } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import dayjs from "dayjs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import {
  BIBlack,
  BIGreen,
  BIGrey,
  BILightGreen,
  BILightGrey,
  BILightRed,
  BILightYellow,
  BIRed
} from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  FETCH_CLIENT_EMP_JOBS_2,
  FETCH_CLIENT_SAFETY_OBSERVATION,
  FETCH_CLIENT_SAR2,
  FETCH_CLIENT_SAR_ACTIONS,
  FETCH_CLIENT_SAR_NOTES2,
} from "../../constant/Apipath";
import ClientSafetyObservationAddModal from "../safety-observation/ClientSafetyObservationAddModal";
import { ClientSafetyObservationViewModal } from "../safety-observation/ClientSafetyObservationViewModal";
import { ClientUDFieldComponent } from "../safety-observation/ClientUDFieldComponent";
import ClientNotesAddModal from "./ClientNotesAddModal";
import ClientSARActionsAddModel from "./ClientSARActionsAddModel";
import ClientSARAddModal from "./ClientSARAddModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../utils/clientEmployeeAppsLicenses";

export default function ClientSARViewModal({ isOpen, onClose, data, sarData1, reload }) {
  const nav = useNavigate();
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const userId = loginData?.userInformation?.UserId;

  const [notesList, setNotesList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [observationList, setObservationList] = useState([]);
  const [sarEditModal, setSarEditModal] = useState(false);
  const [dueDate, setDueDate] = useState(null);
  const [value, setValue] = useState("1");
  const [sarData, setSarData] = useState({});
  const [jobData, setJobData] = useState({});
  const [mainLoader, setMainLoader] = useState(false);
  const [notesLoader, setNotesLoader] = useState(false);
  const [actionLoader, setActionLoader] = useState(false);
  const [observationLoader, setObservationLoader] = useState(false);
  const [shouldSHowActions, setShouldShowActions] = useState(false);
  const [shouldSowObservation, setShouldShowObservation] = useState(false);

  //for multi language
  const LANGUAGE = ClientEnglishFallback.ClientSARViewModal(
    multiLanguageData?.ClientSARViewModal || {}
  );
  const {
    TEXT_JOB,
    TEXT_DATE,
    TEXT_TIME,
    TEXT_OBSERVATION,
    TEXT_NOTES,
    TEXT_TAB_ACTIONS,
    TEXT_DUE
  } = LANGUAGE;

  useEffect(() => {
    if (isOpen) {
      let todaydate = moment();
      let compareDate = moment(sarData1?.dateCreated);
      let diff = todaydate.diff(compareDate, "hours");
      setDueDate(diff);
      fetchJobs();
      getAppLicence();
    }
  }, [isOpen]);

  const fetchJobs = async () => {
    setMainLoader(true);
    let obj = {
      PageNr: 1,
      NrOfRecPerPage: 100,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SearchList: [
        {
          id: data?.id
        }
      ]
    };

    try {
      let res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS_2, obj, loginData?.accessToken);

      if (res?.status === 200) {
        const jobRes = res?.data?.data;
        setJobData(jobRes[0]);
        await fetchSarData(jobRes[0]?.clientJobId);
      }
    } catch (error) {
      console.log("fetchJobs-> Error Fetching Client Job: ", error);
    } finally {
    }
  };
  const getAppLicence = async () => {
    // const obj = {
    //   PageNr: 1,
    //   NrOfRecPerPage: 20,
    //   FullSearch: "",
    //   UserId: loginData?.userInformation?.UserId,
    //   IncludeRecordNr: true,
    //   FetchAllowedRecordsOnly: true,
    //   SearchList: [
    //     {
    //       ClientId: selectedClientData?.ClientId,
    //       EmployeeId: selectedClientData?.ClientEmployeeId
    //     }
    //   ]
    // };
    try {
      let appLicenceResponse = await fetchClientEmployeeAppsLicensesDetails(
        selectedClientData?.ClientId,
        selectedClientData?.ClientEmployeeId,
        loginData?.accessToken
      );
      if (appLicenceResponse.status === 200) {
        const normalizedResponse = normalizeClientEmployeeAppsLicensesResponse(appLicenceResponse);
        // Check if "Chat" is present in the appLicenceResponse data
        const hasActions = Array.isArray(normalizedResponse?.data?.data)
          ? normalizedResponse.data.data.some((item) => item?.AppName === "Actions")
          : false;
        const hasObservation = Array.isArray(normalizedResponse?.data?.data)
          ? normalizedResponse.data.data.some((item) => item?.AppName === "Safety Observations")
          : false;
        setShouldShowActions(hasActions);
        setShouldShowObservation(hasObservation);
      } else {
        console.log("getAppLicence-> Error Getting App Licence Data");
      }
    } catch (error) {
      console.log("getAppLicence-> Error Getting App Licence Data: ", error);
    }
  };

  const fetchSarData = async () => {
    let jobObj = {
      PageNr: 1,
      NrOfRecPerPage: 1,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "Date", Direction: "DESC" }],
      SearchList: [
        {
          id: sarData1?.id
        }
      ]
    };
    try {
      const sarRes = await Postrequestcall(FETCH_CLIENT_SAR2, jobObj, loginData?.accessToken);
      if (sarRes?.status === 200) {
        setSarData(sarRes?.data?.data[0]);
        let SARid = sarRes?.data?.data[0]?.id;
        fetchClientNotes(SARid);
        getObservation(SARid);
        fetchActions(SARid);
      }
    } catch (error) {
      console.log("fetchSarData-> Error Fetching Client SAR: ", error);
    } finally {
      setMainLoader(false);
    }
  };
  const fetchClientNotes = async (SARid) => {
    if (!SARid) return;
    setNotesLoader(true);
    try {
      let payload = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ SARId: SARid }]
      };
      let data = await Postrequestcall(FETCH_CLIENT_SAR_NOTES2, payload, TOKEN);
      if (data?.status == 200) {
        setNotesList(data?.data?.data);
      }
    } catch (error) {
      console.log("fetchClientNotes-> Error Fetching Client SAR Notes: ", error);
    } finally {
      setNotesLoader(false);
    }
  };

  const getObservation = async (SARid) => {
    if (!SARid) return;
    setObservationLoader(true);

    try {
      const payload = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ],
        SearchList: [{ SARId: SARid }]
      };
      let obs = await Postrequestcall(FETCH_CLIENT_SAFETY_OBSERVATION, payload, TOKEN);

      if (obs?.status == 200) {
        setObservationList(obs?.data?.data);
      }
    } catch (err) {
      console.log("getObservation-> Error Fetching Client Safety Observation: ", err);
    } finally {
      setObservationLoader(false);
    }
  };

  const fetchActions = async (SARid) => {
    if (!SARid) return;
    setActionLoader(true);
    try {
      let payload = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ SARId: SARid }]
      };
      let data = await Postrequestcall(FETCH_CLIENT_SAR_ACTIONS, payload, TOKEN);

      if (data?.status == 200) {
        setActionList(data?.data?.data);
      }
    } catch (error) {
      console.log("fetchActions-> Error Fetching Client SAR Actions: ", error);
    } finally {
      setActionLoader(false);
    }
  };

  const resetData = () => {
    setValue("1");
    setNotesList([]);
    setActionList([]);
    setObservationList([]);
    setDueDate(null);
    setSarData({});
    setJobData({});
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const ComponentNotes = ({ multiLanguageData }) => {
    const [selectedData, setSelectedData] = useState({});
    const [notesViewModal, setNotesViewModal] = useState(false);
    const [addNotesModal, setAddNotesModal] = useState(false);
    const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const { TEXT_ADD_NOTE, TEXT_REPORT_DONT_HAVE_ANY_NOTES } = multiLanguageData;
    const handleShow = (index) => {
      setImageIndex(index);
      setPictureViewerOpen(true);
    };

    const NotesViewModal = () => {
      return (
        <>
          <Modal
            open={notesViewModal}
            onClose={() => {
              setNotesViewModal(false);
              setSelectedData({});
            }}>
            <div
              style={{
                maxWidth: "500px"
              }}
              className="client-modal-responsive">
              <div className="action-button-container">
                <IconButton
                  size="small"
                  onClick={() => {
                    setNotesViewModal(false);
                    setSelectedData({});
                  }}
                  sx={{
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                      selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}>
                  <CloseIcon />
                </IconButton>
              </div>
              <Grid container spacing={1} size={12}>
                <Grid size={12}>
                  <Typography>{selectedData?.description}</Typography>
                </Grid>

                {selectedData?.noteTypeName != "" && (
                  <Grid size={12}>
                    <Chip
                      sx={{
                        borderRadius: "5px",
                        color: BIGrey
                      }}
                      label={selectedData?.noteTypeName}
                      size="small"
                    />
                  </Grid>
                )}
                <Grid size={12}>
                  <Stack direction={"row"} spacing={1} overflow={"auto"}>
                    {selectedData?.pictureList?.map((item, i) => (
                      <img
                        loading="lazy"
                        key={i}
                        style={{
                          minHeight: "100px",
                          minWidth: "100px",
                          maxWidth: "100px",
                          maxHeight: "100px",
                          borderRadius: "10px",
                          cursor: "pointer"
                        }}
                        onClick={() => handleShow(i)}
                        src={item?.fileUrl}
                        alt="no data"
                      />
                    ))}
                  </Stack>
                </Grid>
              </Grid>
            </div>
          </Modal>
          <PictureViewer
            isOpen={pictureViewerOpen}
            onClose={() => setPictureViewerOpen(false)}
            pictures={selectedData?.pictureList?.map((item) => ({
              src: item?.fileUrl,
              alt: "picture"
            }))}
            viewerIndex={imageIndex}
          />
        </>
      );
    };
    return (
      <>
        <div
          style={{
            maxHeight: "200px",
            minHeight: "200px",
            overflow: "auto"
          }}>
          {dueDate < 48 && (
            <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
              <Typography
                onClick={() => setAddNotesModal(true)}
                sx={{
                  color: CLIENT_ACCENT_COLOR,
                  fontWeight: "bold",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>
                {TEXT_ADD_NOTE}
              </Typography>
            </Stack>
          )}
          {notesList?.length > 0 ? (
            <>
              <Grid spacing={1} sx={{ mt: 1 }} container size={12}>
                {notesList?.map((item, index) => {
                  return (
                    <Grid key={index} size={12}>
                      <Card
                        onClick={() => {
                          setNotesViewModal(true);
                          setSelectedData(item);
                        }}
                        sx={{
                          borderRadius: "10px",
                          p: 1,
                          boxShadow: "none",
                          cursor: "pointer"
                        }}>
                        <Typography
                          sx={{
                            color: BIGrey
                          }}>
                          {item?.description}
                        </Typography>
                        {item?.noteTypeName != "" && (
                          <Chip
                            sx={{
                              borderRadius: "5px",
                              color: BIGrey
                            }}
                            label={item?.noteTypeName}
                            size="small"
                          />
                        )}
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          ) : (
            <>
              <Stack sx={{ display: "flex", justifyContent: "center" }} height={"150px"}>
                <Typography
                  sx={{
                    color: BIGrey,
                    fontWeight: "bold",
                    textAlign: "center"
                  }}>
                  {TEXT_REPORT_DONT_HAVE_ANY_NOTES}
                </Typography>
              </Stack>
            </>
          )}
        </div>
        <NotesViewModal />
        <ClientNotesAddModal
          open={addNotesModal}
          onClose={() => setAddNotesModal(false)}
          SARid={sarData?.id}
          reloadData={() => {
            fetchClientNotes();
            fetchSarData();
          }}
        />
      </>
    );
  };
  const ComponentObservation = ({ multiLanguageData }) => {
    const [viewObservationModal, setViewObservationModal] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [obsAddModal, setObsAddModal] = useState(false);

    const { TEXT_ADD_OBSERVATION, TEXT_REPORT_DONT_HAVE_OBSERVATION } = multiLanguageData;
    return (
      <>
        <div
          style={{
            maxHeight: "200px",
            minHeight: "200px",
            overflow: "auto"
          }}>
          {dueDate < 48 && (
            <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
              <Typography
                onClick={() => {
                  setObsAddModal(true);
                }}
                sx={{
                  color: CLIENT_ACCENT_COLOR,
                  fontWeight: "bold",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>
                {TEXT_ADD_OBSERVATION}
              </Typography>
            </Stack>
          )}
          {observationList?.length > 0 ? (
            <>
              <Grid spacing={1} sx={{ mt: 1 }} container size={12}>
                {observationList?.map((item, index) => {
                  return (
                    <Grid key={index} size={12}>
                      <Card
                        onClick={() => {
                          setSelectedData(item);
                          setViewObservationModal(true);
                        }}
                        sx={{
                          borderRadius: "10px",
                          p: 1,
                          boxShadow: "none",
                          cursor: "pointer"
                        }}>
                        <Typography
                          sx={{
                            color: BIGrey
                          }}>
                          {item?.description}
                        </Typography>
                        <ClientUDFieldComponent mode="view" udFields={item?.udFieldsList} />
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          ) : (
            <>
              <Stack sx={{ display: "flex", justifyContent: "center" }} height={"150px"}>
                <Typography
                  sx={{
                    color: BIGrey,
                    fontWeight: "bold",
                    textAlign: "center"
                  }}>
                  {TEXT_REPORT_DONT_HAVE_OBSERVATION}
                </Typography>
              </Stack>
            </>
          )}
        </div>
        <ClientSafetyObservationViewModal
          dueDate={dueDate}
          isOpen={viewObservationModal}
          onClose={() => {
            setViewObservationModal(false);
            setSelectedData({});
          }}
          from={"SAR"}
          data={selectedData}
          SARid={sarData?.id}
          reLoadData={() => {
            fetchSarData();
            getObservation();
          }}
        />
        <ClientSafetyObservationAddModal
          SARid={sarData?.id}
          isOpen={obsAddModal}
          mode="ADD"
          onClose={() => setObsAddModal(false)}
          from={"SAR"}
          data={data}
          reLoadData={() => {
            fetchSarData();
            getObservation();
          }}
        />
      </>
    );
  };
  const ComponentActions = ({ multiLanguageData }) => {
    const [addActionModal, setAddActionsModal] = useState(false);

    const { TEXT_ADD_ACTION, TEXT_REPORT_DONT_HAVE_ACTION } = multiLanguageData;
    return (
      <>
        <ClientSARActionsAddModel
          isOpen={addActionModal}
          onClose={() => {
            setAddActionsModal(false);
          }}
          SARid={sarData?.id}
          reloadData={() => {
            fetchActions();
            fetchSarData();
          }}
        />

        <div
          style={{
            maxHeight: "200px",
            minHeight: "200px",
            overflow: "auto"
          }}>
          {dueDate < 48 && (
            <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
              <Typography
                onClick={() => {
                  setAddActionsModal(true);
                }}
                sx={{
                  color: CLIENT_ACCENT_COLOR,
                  fontWeight: "bold",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>
                {TEXT_ADD_ACTION}
              </Typography>
            </Stack>
          )}
          {actionList?.length > 0 ? (
            <Grid spacing={1} sx={{ mt: 1 }} container size={12}>
              {actionList?.map((item, index) => {
                return (
                  <Grid key={index} size={12}>
                    <Card
                      onClick={() => {
                        nav(`../actions/${item?.id}`);
                      }}
                      sx={{
                        borderRadius: "10px",
                        p: 1,
                        boxShadow: "none",
                        cursor: "pointer"
                      }}>
                      <Stack
                        sx={{ display: "flex",  justifyContent: "space-between" }}
                        
                        direction={"row"}>
                        <Stack spacing={1} direction={"row"}>
                          <PersonIcon
                            sx={{
                              color: CLIENT_ACCENT_COLOR
                            }}
                          />
                          <Typography
                            sx={{
                              color: "grey"
                            }}>
                            {item?.employeeName}
                          </Typography>
                        </Stack>

                        <Typography
                          sx={{
                            color: "grey"
                          }}>
                          {`${TEXT_DUE} ${dayjs(item?.dueDate).format("MMMM DD, YYYY ")}`}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography>{` ${item?.title}`}</Typography>
                        <Typography
                          gutterBottom
                          sx={{
                            color: "grey"
                          }}>
                          {` ${item?.description}`}
                        </Typography>
                        <div>
                          <Chip
                            label={item?.status}
                            size="small"
                            style={
                              item?.status === "In Progress"
                                ? {
                                    backgroundColor: BILightYellow,
                                    color: "brown"
                                  }
                                : item?.status === "Overdue"
                                  ? {
                                      backgroundColor: BILightRed,
                                      color: BIRed
                                    }
                                  : item?.status === "Not Started"
                                    ? {
                                        backgroundColor: "#e4e4e4",
                                        color: BIBlack
                                      }
                                    : item?.status === "On Hold"
                                      ? {
                                          backgroundColor: "pink",
                                          color: "brown"
                                        }
                                      : {
                                          backgroundColor: BILightGreen,
                                          color: BIGreen
                                        }
                            }
                          />
                        </div>
                      </Stack>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <>
              <Stack sx={{ display: "flex", justifyContent: "center" }} height={"150px"}>
                <Typography
                  sx={{
                    color: BIGrey,
                    fontWeight: "bold",
                    textAlign: "center"
                  }}>
                  {TEXT_REPORT_DONT_HAVE_ACTION}
                </Typography>
              </Stack>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          resetData();
          onClose();
        }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90%",
              sm: "90%",
              md: "70%",
              lg: "40%",
              xl: "40%"
            },
            backgroundColor: "white",
            borderRadius: "10px"
          }}>
          {mainLoader ? (
            <Stack sx={{ p: 2 }}>
              <Loader />
            </Stack>
          ) : (
            <>
              <Stack sx={{ p: 1 }}>
                {" "}
                <div
                  style={{
                    padding: "0px  0px"
                  }}
                  className="action-button-container">
                  <IconButton
                    size="small"
                    onClick={() => {
                      resetData();
                      onClose();
                    }}>
                    <CloseIcon
                      sx={{
                        color:
                          selectedClientData?.AccentColor !== undefined &&
                          selectedClientData?.AccentColor
                            ? selectedClientData?.AccentColor
                            : BILightGrey
                      }}
                    />
                  </IconButton>
                  {dueDate < 48 && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSarEditModal(true);
                      }}>
                      <Edit
                        sx={{
                          color: CLIENT_ACCENT_COLOR
                        }}
                      />
                    </IconButton>
                  )}
                </div>
                <Stack sx={{ padding: {
                    xs: 0,
                    md: 0,
                    lg: 1,
                    xl: 1, paddingTop: "0px !important" }} }>
                  <Grid sx={{ pr: 1,  pl: 1, display: "flex", flexDirection: "column" }} container>
                    <Grid spacing={1} size={12} container>
                      <Grid size={8}>
                        <Typography
                          sx={{ margin: 0 }}
                          style={{
                            color: BIGrey
                          }}
                          variant="subtitle1"
                          gutterBottom>
                          {TEXT_JOB}
                        </Typography>
                        <Typography>{`${jobData?.jobCode} - ${jobData?.jobName}`}</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography
                          sx={{ margin: 0, 
                            color: BIGrey
                          }}
                          
                          variant="subtitle1"
                          gutterBottom>
                          {TEXT_DATE}
                        </Typography>
                        <Typography>{dayjs(sarData?.date).format("MMMM DD, YYYY")}</Typography>
                      </Grid>
                      <Grid size={4}>
                        <Typography
                          sx={{ margin: 0, 
                            color: BIGrey
                          }}
                          
                          variant="subtitle1"
                          gutterBottom>
                          {TEXT_TIME}
                        </Typography>
                        <Typography>{moment.utc(sarData?.time).local().format(" h:mm A")}</Typography>
                        
                      </Grid>
                    </Grid>

                    <Grid size={12}>
                      <Typography
                        sx={{
                          maxHeight: "60px",
                          wordBreak: "break-all",
                          overflow: "auto"
                        }}>
                        {sarData?.weather}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
              <Grid container size={12}>
                <Grid size={12}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        sx={{
                          "& .MuiTabs-indicator": {
                            background: CLIENT_ACCENT_COLOR,
                            height: 3
                          },
                          "& .MuiTab-root.Mui-selected": {
                            color: CLIENT_ACCENT_COLOR
                          }
                        }}
                        variant={"fullWidth"}
                        onChange={handleChange}>
                        <Tab
                          sx={{
                            textTransform: "none",
                            fontWeight: "bold"
                          }}
                          label={`${TEXT_NOTES} (${sarData?.nrOfSARNotes})`}
                          value="1"
                        />
                        {shouldSowObservation && (
                          <Tab
                            sx={{
                              textTransform: "none",
                              fontWeight: "bold"
                            }}
                            label={
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center"
                                }}>
                                {TEXT_OBSERVATION} ({sarData?.nrOfObservations})
                              </span>
                            }
                            value="2"
                          />
                        )}
                        {shouldSHowActions && (
                          <Tab
                            sx={{
                              textTransform: "none",
                              fontWeight: "bold"
                            }}
                            label={`${TEXT_TAB_ACTIONS} (${sarData?.nrOfSARActions})`}
                            value="3"
                          />
                        )}
                      </TabList>
                    </Box>
                    <TabPanel
                      sx={{
                        backgroundColor: "#e4e4e4",
                        padding: "0px 10px",
                        paddingBottom: "10px",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px"
                      }}
                      style={{}}
                      value="1">
                      {notesLoader ? (
                        <Stack sx={{ alignItems: "center" }}>
                          <Loader />
                        </Stack>
                      ) : (
                        <ComponentNotes multiLanguageData={LANGUAGE} />
                      )}
                    </TabPanel>
                    <TabPanel
                      sx={{
                        backgroundColor: "#e4e4e4",
                        padding: "0px 10px",
                        paddingBottom: "10px",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px"
                      }}
                      value="2">
                      {observationLoader ? (
                        <Stack sx={{ alignItems: "center" }}>
                          <Loader />
                        </Stack>
                      ) : (
                        <ComponentObservation multiLanguageData={LANGUAGE} />
                      )}
                    </TabPanel>
                    <TabPanel
                      sx={{
                        backgroundColor: "#e4e4e4",
                        padding: "0px 10px",
                        paddingBottom: "10px",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px"
                      }}
                      value="3">
                      {actionLoader ? (
                        <Stack sx={{ alignItems: "center" }}>
                          <Loader />
                        </Stack>
                      ) : (
                        <ComponentActions multiLanguageData={LANGUAGE} />
                      )}
                    </TabPanel>
                  </TabContext>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Modal>
      <ClientSARAddModal
        data={data}
        sarData={sarData}
        isOpen={sarEditModal}
        onClose={() => setSarEditModal(false)}
        mode="EDIT"
        reload={() => reload()}
      />
    </>
  );
}
